import React from 'react'
import BaseField from './BaseField'


export default function FieldTextArea(props) {
  /* Input Text Area
   * Expected Props:
   * className = <string> Optional
   * label = <string> Required
   * required = <boolean> Optional
   * name = <string> Required
   * value = <string> Required
   * placeholder = <string> Optional
   * valid = <boolean> Optional
   * validMessage = <string> Optional
   * invalidMessage = <string> Optional
   * help = <string> Optional
   * helpAboveInput = <boolean> Optional
   * onChange = <function()> Required
   * onBlur = <function()> Optional
   * disabled = <boolean> Optional
   * rows = <integer> Optional
   * maxLength = <integer> Optional
   * resize = <boolean> Optional
   */

  // RENDER
  return (
    <BaseField
      className={props.className}
      label={props.label}
      input={
        <textarea
          className={"form-control custom-field-input" + (
            props.valid === true ? " is-valid" : props.valid === false ? " is-invalid" : ""
          )}
          name={props.name}
          placeholder={props.placeholder}
          value={props.value || ""}
          required={props.required && props.valid === false}
          onChange={props.onChange}
          onBlur={props.onBlur}
          disabled={props.disabled}
          rows={props.rows ? props.rows : 3}
          maxLength={props.maxLength}
          style={props.resize === false ? { resize: "none" } : null}
        />
      }
      required={props.required}
      valid={props.valid}
      validMessage={props.validMessage}
      invalidMessage={props.invalidMessage}
      help={props.help}
      helpAboveInput={props.helpAboveInput}
    />
  )
}
